<template>
  <component
    :is="componentTitle"
    :deal="deal"
    :extended="extended"
    :shortened="shortened"
    :active="active"
    :selected="selected"
    :archivable="archivable"
    :unarchivable="unarchivable"
    :dealType="dealType"
    @toggle="toggleSelected"
    @archive="archive"
    @unarchive="unarchive"
  />
</template>

<script>
import normalDeal from './items/normal-deal.vue'
import lpDeal from './items/lp-deal.vue'

export default {
  name: 'deal-item',
  components: { normalDeal, lpDeal },
  props: {
    deal: {
      type: Object,
      default: () => {}
    },
    extended: {
      type: Boolean,
      default: false
    },
    shortened: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    archivable: {
      type: Boolean,
      default: false
    },
    unarchivable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    componentTitle () {
      if (this.dealType === 'LP Equity') {
        return 'lp-deal'
      }
      return 'normal-deal'
    },
    dealType () {
      if (!this.deal) return ''
      if (this.deal.isLpEquity) {
        return 'LP Equity'
      }
      if (this.deal.isEquityInvestment && this.deal.isTradeDeal) return 'Both'
      if (this.deal.isEquityInvestment) return 'Investment'
      if (this.deal.isTradeDeal) return 'Trade'
      return 'Flexible'
    }
  },
  methods: {
    toggleSelected () {
      if (!this.active) return
      const id = this.deal._id || this.deal.id
      this.$emit('select', id)
    },
    archive () {
      this.deal.archivedAt = Date.now()
      this.$emit('archive', this.deal._id)
    },
    unarchive () {
      this.deal.archivedAt = null
      this.$emit('unarchive', this.deal._id)
    }
  }
}
</script>
